/**
 *
 * ActionPlanTaskResumen
 *
 */

import React, { Fragment } from "react"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { Dropdown, Menu, Avatar, Checkbox, Popover } from "antd"
import pointMenu from "images/three-points-gray.svg"
import checkIcon from "images/check.svg"
import fullCheckIcon from "images/full-check.svg"
import { loadTexts } from "../../utils/i18n"
import "./index.less"
import { buttonAction_btns } from "../Snowplow/config2"
import moment from "moment"
/* eslint-disable react/prefer-stateless-function */
class ActionPlanTaskResumen extends React.Component {
  intl = loadTexts("dashboard")

  state = {
    isOpen: true,
    periodicity: [
      "No se repite",
      "Semanal",
      "Quincenal",
      "Mensual",
      "Trimestral",
      "Semestral",
      "Anual",
    ],
    taskScheduler:this.props.data.task_schedules
  }

  onUpdateActionPlan=(e) => {
    
    this.props.onReloadActionPlan(e)
  }

  updateTaskStatus = async (taskId, task, done) => {
    done = done ? 1 : 0
   /*  const updatedTasks = this.state.taskScheduler.map((t) =>
      t.task_date === task.task_date ? { ...t, done: newDoneStatus } : t
    );
    this.setState({ taskScheduler: updatedTasks });
    console.log('updateTaskStatus',updatedTasks)
    this.props.onReloadActionPlanTask(updatedTasks) */
    const updatedTaskSchedules = this.state.taskScheduler.map((d) => {
      if (task.task_date === d.task_date) {
        return { ...task, done: done };
      }
      return d;
    });
    const updatedData = {
      ...this.props.data, // Copia de las demás propiedades de data
      task_schedules: updatedTaskSchedules // Actualización de task_schedules
    };
    this.setState({ taskScheduler: updatedTaskSchedules })
    this.props.onReloadActionPlanTask(updatedData)
    
  };

  render() {
    const { periodicity,taskScheduler } = this.state
    const { data, onEdit, onDelete } = this.props
    const date_end =
      data.date_end && typeof data.date_end === "object"
      ? data.date_end.format("Y-MM-DD")
      : moment(data.date_end, ["YYYY-MM-DD", "DD/MM/YYYY"]).isValid()
      ? moment(data.date_end, ["YYYY-MM-DD", "DD/MM/YYYY"]).format("YYYY-MM-DD")
      : data.date_end;
    const date_start =
      data.date_start && typeof data.date_start === "object"
        ? data.date_start.format("Y-MM-DD")
        : moment(data.date_start, ["YYYY-MM-DD", "DD/MM/YYYY"]).isValid()
        ? moment(data.date_start, ["YYYY-MM-DD", "DD/MM/YYYY"]).format("YYYY-MM-DD")
        : data.date_start;
    const canChangeStatus =
    validRole({ role: [1, 2, 3, 4,5] })  || data.editable
    const dateTask = (
      <Fragment>
        <div className="ActionPlanTasks-component-detail-next-dates-title">
          {this.intl.actionPlanTaskForm.labels.taskScheduler}
        </div>
        <div
          className="ActionPlanTasks-component-detail-next-dates"
          style={{ maxHeight: 200, overflow: "auto" }}>
          {taskScheduler &&
            taskScheduler.map((d, di) => (
              <Checkbox disabled={!canChangeStatus}  onClick={() =>
                this.updateTaskStatus(2, d, !d.done)
              } key={di} checked={d.done}>
                {d.task_date || d}
              </Checkbox>
            ))}
        </div>
      </Fragment>
    )
    const allDone = data.periodicity !== 0 ?taskScheduler.every(task => task.done == true) : data.done;
    return (
      <div className="ActionPlanTaskResumen-component">
        <div
          className="ActionPlanTaskResumen-component-row"
          style={{ gridTemplateColumns: "30px auto 200px" }}>
          <div>
            <img
              src={allDone ? fullCheckIcon : checkIcon}
              style={{ width: 20 }}
            />
          </div>
          <div>
            <span>{data.name}</span>
          </div>
          <div  style={{ flex: 1, display: 'flex', justifyContent: 'flex-end',height: '20px' }}>
            <b style={{ marginRight: "6px" }}>{this.intl.actionPlanTaskForm.labels.endDate}:</b>

            <span className="color-gray-low">   {moment(date_end).format("DD/MM/YYYY")}</span>
          </div>

        </div>
        {data.employees && data.employees[0] && (
          <div
            className="ActionPlanTaskResumen-component-row"
            style={{ gridTemplateColumns: "30px auto 200px", marginTop: -10 }}>
            <div />
            <div>
              <Avatar
                src={data.employees[0].picture_profile}
                size={20}
                style={{ display: "inline-block" }}
              />
              <span
                className="ActionPlanTaskResumen-component-row-name string_dots"
                style={{
                  display: "inline-block",
                  verticalAlign: "middle",
                  marginLeft: 5,
                }}>
                {data.employees[0].full_name}
              </span>
            </div>
            <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end',height: '20px' }}>
              <span style={{ color: "#2694FC",cursor: 'pointer',fontWeight: 600 }} onClick={() => {buttonAction_btns("Editar tarea"); onEdit(data);}}>
                  {this.intl.actionPlanTask.actions.edit}

                            </span>

                            <span style={{ color: "#E37879",cursor: 'pointer', marginLeft: "10px", fontWeight: 600 }}  onClick={() => onDelete(data)}>
                            {this.intl.actionPlanTask.actions.delete}

                            </span>
                            </div>
          </div>
        )}

        {data.periodicity !== 0 && (
          <div
            className="ActionPlanTaskResumen-component-info"
            style={{ marginTop: -2 }}>
            <div>
              <b>{this.intl.actionPlanTaskForm.labels.periodicity}:</b>{" "}
              {periodicity[data.periodicity]}
            </div>
            <div>
              <b>{this.intl.actionPlanTaskForm.labels.startDate}:</b>{" "}
              { moment(date_start).format("DD/MM/YYYY")}
            </div>
            <div>
              <b>{this.intl.actionPlanTaskForm.labels.countTasks}:</b>{" "}
              <Popover
                placement="bottomLeft"
                content={dateTask}
                trigger="click">
                <span style={{ cursor: "pointer", color: "#1890FF" }}>
                  {taskScheduler.length}{" "}
                  {plural(
                    this.intl.actionPlanTaskForm.labels.taskWord,
                    taskScheduler.length,
                    "s"
                  )}
                </span>
              </Popover>
            </div>
          </div>
        )}
      </div>
    )
  }
}

ActionPlanTaskResumen.propTypes = {}

export default ActionPlanTaskResumen
